module.exports = {"220681001":"建国街道","220681002":"新市街道","220681003":"兴隆街道","220681004":"大湖街道","220681005":"森工街道","220681006":"大栗子街道","220681100":"桦树镇","220681101":"六道沟镇","220681102":"苇沙河镇","220681103":"花山镇","220681104":"闹枝镇","220681105":"四道沟镇","220681200":"蚂蚁河乡","220681400":"临江经济开发区","220681401":"临江硅藻土工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220681.json
// module id = 651
// module chunks = 0